/**
 * Builds the qPublic (Schneider Corp) tax-record lookup URL for a Maui
 * County parcel, keyed off our 13-digit normalized TMK. qPublic's KeyValue
 * expects the TMK without its leading county-code digit (our normalized
 * form: 2xxxxxxxxxxxx for Maui) - same URL pattern already used, standalone,
 * in apps/admin/src/pages/Geography.ts's neighborhood-unit list.
 *
 * qPublic sends X-Frame-Options: SAMEORIGIN, so it can't be embedded in an
 * iframe on our domain - callers open this via window.open() as a popup,
 * not a modal iframe.
 */
export function buildQpublicUrl(tmkNormalized) {
    return `https://qpublic.schneidercorp.com/Application.aspx?AppID=1029&LayerID=21689&PageTypeID=4&PageID=9251&KeyValue=${tmkNormalized.substring(1)}`;
}
const QPUBLIC_POPUP_FEATURES = 'width=1000,height=800,menubar=no,toolbar=no,location=yes,status=no,scrollbars=yes,resizable=yes';
/** Opens a parcel's qPublic tax record in a small, closeable popup window. */
export function openQpublicPopup(tmkNormalized) {
    window.open(buildQpublicUrl(tmkNormalized), 'qpublic-tmk', QPUBLIC_POPUP_FEATURES);
}
//# sourceMappingURL=qpublicLink.js.map